module.exports = __webpack_public_path__ + "media/images/pic/teachers/magdalena-kisly-52bf18ae4365885e7e94eff6aa9f3588.png";